export default __webpack_public_path__ + "static/media/480_business01-jp-web.b8d25dab.png";